import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import GenericForm from "../genericForm";

function UserInternalAdd() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [data] = useState({});
	const [error] = useState("");

	const inputFields = [
		{ type: "text", name: "first_name", label: "Nome", required: true },
		{ type: "text", name: "last_name", label: "Cognome", required: true },
		{ type: "text", name: "fiscal_code", label: "Codice fiscale", required: true },
		{ type: "date", name: "date_of_birth", label: "Data di nascita", required: true },
		{ type: "text", name: "email", label: "Email", required: true },
		{ type: "text", name: "phone", label: "Telefono", required: true },
		{ type: "text", name: "password", label: "Password", required: true },
	];

	const requiredFields = [
		{ name: "first_name", nameDiplayed: "Nome" },
		{ name: "last_name", nameDiplayed: "Cognome" },
		{ name: "fiscal_code", nameDiplayed: "Codice fiscale" },
		{ name: "date_of_birth", nameDiplayed: "Data di nascita" },
	];

	return (
		<>
			{authContext.hasAuth("ADD_INTERNAL_USER") ? (
				<DashboardLayout>
					<DashboardNavbar />
					<MDBox pt={6} pb={3}>
						<Button variant="contained" color="primary" onClick={() => navigate("/users-internal-managment")} sx={{ mt: 2, alignSelf: "center", minWidth: "100px", color: "#ffffff", marginBottom: "30px" }}>
							Torna alla tabella
						</Button>
						{error !== "" ? (
							<Alert severity="error">{error}</Alert>
						) : (
							<GenericForm
								inputFields={inputFields}
								requiredFields={requiredFields}
								authModelName={"INTERNAL_USER"}
								url="/user-internal-management/"
								old_data={data}
								useAPI={true} // cambia a true per usare l'API
								redirectOnSuccess="/users-internal-managment/edit"
							/>
						)}
					</MDBox>
				</DashboardLayout>
			) : (
				<DashboardLayout>
					<MDAlert color="error" dismissible>
						<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
					</MDAlert>
				</DashboardLayout>
			)}
		</>
	);
}

export default UserInternalAdd;
